// Firebase configuration for web authentication
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, type User } from 'firebase/auth';

// Firebase configuration - real web app config from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyB6kgsmIqr1Tvty5rnnGli0aYdSa9PN7rY",
  authDomain: "languageapp-6d8ca.firebaseapp.com",
  projectId: "languageapp-6d8ca",
  storageBucket: "languageapp-6d8ca.firebasestorage.app",
  messagingSenderId: "461562917560",
  appId: "1:461562917560:web:4962dc7a2cf262a5c7ba4d",
  measurementId: "G-5TH46LWC73"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Configure Google Auth Provider with same web client ID as mobile app
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// The mobile app uses this web client ID: 461562917560-j75ltmugckuauamkb30rqs5785u2hp2i.apps.googleusercontent.com
// This is already configured in the mobile app's GetStarted.tsx file

// Export authentication functions - re-export from firebase/auth
export { signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
export { googleProvider };
export type { User };